import { createSlice } from "@reduxjs/toolkit";

export const dureeSlice = createSlice({ //reducers for both hours in global state
    name: 'duree',
    initialState:{},
    reducers: {
        setDuree: (currentState, action) => {
            return action.payload
        }
    }
});